import { MenuItems } from '@menu-lib/components/AppLayout/MainMenu/menuItems';
import { MenuItemRegistry } from '@menu-lib/components/AppLayout/MainMenu/menuRegistry';
import { type EnvironmentSettings, type LinkItem } from '@menu-lib/components/AppLayout/types';

MenuItemRegistry.register(MenuItems.Adviseurbeheer, {
  isVisible: (settings: EnvironmentSettings) =>
    settings.isInterneGebruiker && settings.heeftAdviseurbeheerRechten,
  create: (): LinkItem => ({
    itemtype: 'link',
    menuItem: MenuItems.Adviseurbeheer,
    title: 'Adviseurbeheer',
    url: '/app/crm/adviseurs',
    iconclass: 'far fa-handshake-simple',
    target: '_top',
  }),
});
